import axios from 'axios'

type Props = {
    paramId: string;
    rotaryCd: string;
}

/**
 * 出席にする日付のリストを取得するAPI
 */
export async function getSelectDate({paramId, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/makeup/selectdate`, {
        params: {
            rotaryCd: rotaryCd,
            paramId: paramId
        }
    })
    
    return JSON.parse(JSON.stringify(response.data));
}